module.exports = __webpack_public_path__ + "img/KinokoTable63.20960d69.jpg";